// extracted by mini-css-extract-plugin
module.exports = {"HotelImageSquare":"HotelImageSquare_HotelImageSquare__3YTj9","iconContainerClassName":"HotelImageSquare_iconContainerClassName__1TwHA"};